import AScene from "../../library/ExtendedObjects/AScene.js";
import gameData from "../../gameData.js";
import NavBar from "./NavBar.js";
import Vials from "./Vials.js";
import DragBug from "../DragBug.js";
import Popup from "./Popup.js";
import ABCyaPhaser, { Audio } from "@abcya/abcya_phaser";
import LocalizationUIAssets from "../../Localization-UIAssets.js";

export default class Game extends AScene {
  static get KEY() { return 'Game'; }

  create() {
    //console.log("GAME!");
    gameData.currentScene = "Game";
    gameData.gameOver = false;
    gameData.gamePaused = false;
    gameData.roundOver = false;
    gameData.totalBugs = 0;
    gameData.totalBugCount = 0;
    gameData.level = 0;
    gameData.score = 0;

    this.inst = null;

    //console.log(gameData.fuzzColor, gameData.fuzzColorName, gameData.fuzzStencil, gameData.fuzzStencilColor, gameData.fuzzStencilName);

    this.createGame();
  }

  createGame() {
    this.initializePattern();
    this.createAssets();

    //this.createJarLevel();
    //this.initializeQuestions();
  }

  initializePattern() {
    //set 5 random colors
    this.selectedColors = [...gameData.fuzzColors];
    this.shuffleArray(this.selectedColors);

    for (let i = 0; i < 4; i++) {
      this.selectedColors.pop();
    }

    //set number of bugs for each vial
    let s1 = Phaser.Math.Between(2, 3);
    let s2 = Phaser.Math.Between(s1 + 1, 5);
    let s3 = Phaser.Math.Between(s2 + 1, 7);
    let s4 = Phaser.Math.Between(s3 + 1, 9);
    this.vialAmounts = [s1, s2, s3, s4];
    this.shuffleArray(this.vialAmounts);
    //console.log(this.vialAmounts);

    //calculate total number of bugs needed
    this.allColors = [];
    let ind = 0;
    for (let i = 0; i < this.vialAmounts.length; i++) {
      gameData.totalBugs += this.vialAmounts[i];

      //create an array with all necessary colors for drag bugs
      for (let s = 0; s < this.vialAmounts[i]; s++) {

        const obj = { color: this.selectedColors[i], ind: i };

        this.allColors.push(obj);
      }
    }
  }

  createAssets() {
    //console.log(gameData.fuzzColor, gameData.fuzzStencilColor, gameData.fuzzStencil, gameData.customReplacementID)
    this.bg = this.addImage(this.mid.x, this.mid.y, "Bckg");

    if (this.shelf) this.shelf.destroy();
    this.shelf = this.addImage(-300, this.mid.y + 62, "Platform");

    if (this.navBar) this.navBar.destroy();
    this.navBar = new NavBar(this);
    this.addToParent(this.navBar);

    if (gameData.level === 0) {
      this.playSound("platform_tween");
      this.addDelay(500, () => {
        this.playSound("sort_by_color", 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);
        gameData.levelSound = "sort_by_color";
      });
      this.addTween(this.shelf, 1000, { x: this.mid.x }, Phaser.Math.Easing.Quadratic.Out);
    } else {
      this.shelf.x = this.mid.x;
    }

    this.vials = new Vials(this, this.selectedColors);

    this.dragBugs = [];
    for (let a = 0; a < gameData.totalBugs; a++) {
      let randX = Phaser.Math.Between(75, this.mid.x * 2 - 75);
      let fb = new DragBug(this, randX, this.mid.y * 2 - 30, .3, "Idle", a, this.allColors[a].ind);

      this.dragBugs.push(fb);

      fb.color = fb.startColor = this.allColors[a].color.color;
      fb.colorName = fb.startColorName = this.allColors[a].color.name;
    }

    let customVial;
    this.vials.vials.forEach((vial) => {
      if (vial.isCustom) customVial = vial;
    });


    this.dragBugs.forEach((bug) => {
      //console.log(bug.startColor, customVial.startColor);

      if (gameData.customFuzzbug) {
        if (bug.startColor === customVial.startColor) {
          bug.patternID = gameData.customReplacementID;
          bug.isPattern = true;
          bug.customizeUser();
        } else {
          bug.paintFuzzbug();
        }
      } else {
        bug.paintFuzzbug();
      }
    });
  };

  goToQuestions() {
    gameData.level++;
    this.navBar.updateLevel();

    // console.log("Going to questions", gameData.level);

    if (gameData.level === gameData.totalLevels) {
      // console.log("GAME OVER");
      gameData.gameOver = true;

      if (gameData.customFuzzbug) this.scene.createTrueEnding();
    }
    else if (gameData.level === 1 || gameData.level === 3 || gameData.level === 5 || gameData.level === 7) {
      if (gameData.level === 1) {
        this.inst = this.playSound("lets_count_fb_each_jar", 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);
        gameData.levelSound = "lets_count_fb_each_jar";
      } else {
        if (this.inst) this.inst.paused = true;
        this.inst = this.playSound("select_another_jar", 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);
        gameData.levelSound = "select_another_jar";
      }
      this.vials.toggleVials(true);
    }
    else if (gameData.level === 9) {
      //wait for audio to play
      this.vials.removeCounter();
      this.vials.toggleVials(true);

      if (this.inst) this.inst.stop();
      this.inst = this.playSound("nice_job_counted_all_fb", 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);
      gameData.levelSound = "nice_job_counted_all_fb";

      this.addDelay(4000, () => { this.goToQuestions(); });
    }
    else if (gameData.level === 10) {
      //wait for audio to play
      if (this.inst) this.inst.stop();
      this.inst = this.playSound("select_jar_least_fb", 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);
      gameData.levelSound = "select_jar_least_fb";

      this.dragBugs.forEach((bugs) => { bugs.character.play("Idle", true); });
      this.vials.setMinMax();
    }
    else if (gameData.level === 11) {
      //wait for audio to play
      if (this.inst) this.inst.stop();
      this.inst = this.playSound("select_jar_most_fb", 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);
      gameData.levelSound = "select_jar_most_fb";

      this.vials.toggleVials(true);
      this.dragBugs.forEach((bugs) => { bugs.character.play("Idle", true); });
    }
    else if (gameData.level === 12) {
      //wait for audio to play
      if (this.inst) this.inst.stop();
      this.playSound("jar_tween");
      this.inst = this.playSound("organize_jars", 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);
      gameData.levelSound = "organize_jars";

      this.dragBugs.forEach((bugs) => { bugs.character.play("Idle", true); });
      this.createJarLevel();
    }
    else if (gameData.level === 13) {
      //wait for audio to play - tap a jar
      if (this.inst) this.inst.stop();
      this.inst = this.playSound("tap_on_a_jar", 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);
      gameData.levelSound = "tap_on_a_jar";

      this.dragBugs.forEach((bugs) => {
        bugs.isCorrect = false;
        bugs.isOrganizing = true;
        bugs.character.play("Idle", true);
      });
      this.vials.toggleVials(true);
      this.vials.removeCounters();
    }
  };

  createJarLevel() {
    //console.log(gameData.vialBugs);
    let tempArr = [...gameData.vialBugs];
    let sortedArr = [];

    for (let i = 0; i < tempArr.length; i++) {
      sortedArr.push(tempArr[i].length);
    }
    sortedArr.sort();
    //console.log(sortedArr);

    this.vials.enableDrag();

    this.outlines = [];
    for (let i = 0; i < 4; i++) {
      let outline = this.addImage(0, 0, "Jar_Silhouette");
      outline.ind = i;
      outline.isFilled = false;
      outline.correctNum = sortedArr[i];

      if (i < 2) {
        outline.startX = -outline.width / 2;
      } else {
        outline.startX = this.mid.x * 2 + outline.width / 2;
      }

      outline.endX = this.vials.vials[i].bottomVials[0].x;
      outline.startY = 620;

      outline.setPosition(outline.startX, outline.startY);

      this.addDelay(75 * i, () => { this.playSound("jar_tween"); });
      this.addTween(outline, 500, { x: outline.endX, delay: 75 * i }, Phaser.Math.Easing.Quadratic.Out);

      this.outlines.push(outline);
    }
  }

  activateBugs(vial) {
    //console.log(vial, gameData.vialBugs[vial.ind]);
    for (let i = 0; i < gameData.vialBugs[vial.ind].length; i++) {
      let newX;
      let newY;

      this.killTween(gameData.vialBugs[vial.ind][i]);

      if (i <= 2) {
        newX = vial.bottomVials[0].x - vial.bottomVials[0].list[0].width / 2 + 35 + (55 * i);
        newY = gameData.vialBugs[vial.ind][i].y;
      }
      else if (i > 2 && i <= 5) {
        newX = vial.bottomVials[0].x - vial.bottomVials[0].list[0].width / 2 + 35 + (55 * (i - 3));
        newY = gameData.vialBugs[vial.ind][i].y - 50;
      }
      else if (i > 5) {
        newX = vial.bottomVials[0].x - vial.bottomVials[0].list[0].width / 2 + 35 + (55 * (i - 6));
        newY = gameData.vialBugs[vial.ind][i].y - 100;
      }

      gameData.vialBugs[vial.ind][i].jarPos = { x: newX, y: newY };
      this.addTween(gameData.vialBugs[vial.ind][i], 500, { x: newX, y: newY }, Phaser.Math.Easing.Quadratic.Out,
        () => {
          gameData.vialBugs[vial.ind][i].isDragging = false;
          gameData.vialBugs[vial.ind][i].enabled(true);
        });
    }
  };

  pauseGame() {
    gameData.gamePaused = true;

    this.playSound("click");

    this.navBar.home.setEnabled(false);

    this.popup = new Popup(this);
  }

  resumeGame() {
    gameData.gamePaused = false;

    this.navBar.home.setEnabled(true);

    this.popup.destroy();
  }

  playIncorrectSound() {
    this.iSounds = ["incorrect1", "incorrect2", "incorrect3", "incorrect4"];
    let rand = Phaser.Math.Between(0, 3);
    this.playSound(this.iSounds[rand], 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);
  }

  enableBugs() {
    this.dragBugs.forEach((bug) => { bug.enabled(true); });
  }

  disableBugs() {
    this.dragBugs.forEach((bug) => { bug.disabled(); });
  }

  setOutlinePos(jar, vial) {
    for (let i = 0; i < gameData.vialBugs[vial.ind].length; i++) {
      let newX;
      let newY;

      this.killTween(gameData.vialBugs[vial.ind][i]);

      if (i <= 2) {
        newX = jar.x - jar.width / 2 + 35 + (55 * i);
        newY = jar.y + jar.height / 2 - 2;
      }
      else if (i > 2 && i <= 5) {
        newX = jar.x - jar.width / 2 + 35 + (55 * (i - 3));
        newY = jar.y + jar.height / 2 - 52;
      }
      else if (i > 5) {
        newX = jar.x - jar.width / 2 + 35 + (55 * (i - 6));
        newY = jar.y + jar.height / 2 - 102;
      }

      gameData.vialBugs[vial.ind][i].outlinePos = { x: newX, y: newY };
    }
  };

  tweenOutGame() {
    // console.log("tweening out TO CUSTOMIZER");
    gameData.roundOver = true;
    this.navBar.tweenOutNav();

    this.vials.tweenOutVials();

    for (let i = 0; i < this.outlines.length; i++) {
      this.addTween(this.outlines[i], 1000, { x: "-=" + this.scale.width }, Phaser.Math.Easing.Quadratic.In);
    }

    this.dragBugs.forEach((bugs) => { bugs.tweenOut(); });

    this.addTween(this.shelf, 1000, { x: -500 }, Phaser.Math.Easing.Quadratic.In,
      () => { this.cleanUp("Customize"); });
  };

  createTrueEnding() {
    // console.log("GAME OVER!");
    this.navBar.tweenOutNav();
    this.vials.tweenOutVials();
    this.dragBugs.forEach((bugs) => { bugs.tweenOut(); });

    this.addTween(this.shelf, 1000, { x: -550 }, Phaser.Math.Easing.Quadratic.In);

    for (let i = 0; i < this.outlines.length; i++) {
      this.addTween(this.outlines[i], 1000, { x: "-=" + this.scale.width }, Phaser.Math.Easing.Quadratic.In);
    }

    this.title = this.addImage(this.mid.x, -200, LocalizationUIAssets._FuzzTastic, ABCyaPhaser.Images.LOCALIZATION_ATLAS);
    this.restartBtn = this.addButton(this.mid.x, this.mid.y + 200, "Btn_Play_Again", {}, () => {
      this.restartBtn.setEnabled(false);
      this.cleanUp("Intro");
    });

    this.restartBtn.setScale(0);
    this.restartBtn.setEnabled(false);
    this.title.setDepth(10);
    this.restartBtn.setDepth(10);

    this.playSound("fuzztastic", 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);

    this.addTween(this.title, 1000, { y: this.title.width / 2 - 100 }, Phaser.Math.Easing.Back.Out,
      () => {
        this.addTween(this.restartBtn, 1000, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Back.Out,
          () => {
            this.restartBtn.setEnabled(true);
          });
      });
  };

  cleanUp(scene) {
    this.dragBugs.forEach((bug) => {
      bug.cleanUp();
      bug = null;
    });
    this.dragBugs = [];
    this.selectedColors = [];
    gameData.vialBugs = [[], [], [], []];
    gameData.upDownBugs = [];
    gameData.gameOver = false;
    gameData.roundOver = false;
    gameData.transition = false;
    gameData.selectedJar = null;
    gameData.counter = 0;
    gameData.score = 0;
    gameData.level = 0;
    gameData.totalBugs = 0;
    gameData.totalBugCount = 0;
    gameData.fuzzIndex = 0;

    if (this.numPad) {
      this.numPad.cleanUp();
      this.numPad.destroy();
    }
    
    this.navBar.destroy();
    this.shelf.destroy();

    this.vials.cleanUp();
    this.vials.destroy();

    if (scene) this.scene.start(scene);
  }
}